module.exports = __webpack_public_path__ + "static/img/bfsxswmhq.7ea37a2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/view/microFireHouse/images/prodImgs/bfsxswmhq.jpg
// module id = RDLv
// module chunks = 21